import React from 'react';
import PropTypes from 'prop-types';
import agent from 'agent';
import { connect } from 'react-redux';
import { PLAYLIST_GET_INFO, PLAYLIST_GET_TYPE_ALL, TOPIC_DETAIL_UNLOAD, MUSIC_SEARCH_LABEL_LOAD_All } from 'constants/actionTypes';
import { redirectTo } from 'dispatch';
import "./TopicMusic.less";

class AllTopicMusic extends React.Component {
    static propTypes = {
        playlistInfos: PropTypes.array.isRequired,
        getPlaylistInfos: PropTypes.func.isRequired,
        getAllPlaylistType: PropTypes.func.isRequired,
        audioList: PropTypes.object.isRequired,
        search: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired,
        unLoadTopic: PropTypes.func.isRequired,
        labels: PropTypes.object.isRequired,
        loadLabelAll: PropTypes.func.isRequired,
    };

    state = {
        topicId: null,
    };

    defaultPager = { pageSize: 10, current: 1 };

    selectRef = null;

    componentDidMount() {

        if (!this.props.playlistInfos.length) this.props.getPlaylistInfos();
        this.props.getAllPlaylistType({ pager: this.defaultPager });
        const { loadLabelAll } = this.props;
        loadLabelAll();
    }

    gotoPlayTypePage(id) {
        redirectTo(`/topicmusic?id=${id}`);
    }
    changePlayList(e) {
        this.setState({ topicId: e.target.value });
        this.props.getAllPlaylistType({
            topicId: e.target.value,
            pager: {
                ...this.props.audioList[this.state.topicId].pager,
                current: 1,
            },
        });
        redirectTo({
            pathname: location.pathname,
            search: `?id=${e.target.value}`,
        });
    }

    getTopic() {
        const [info = {}] = this.props.playlistInfos.filter(x => x.playlistid === this.state.topicId) || [];
        const { title, subtitle, status } = info;
        return { title, subtitle, status };
    }

    onPageChange(page) {
        this.props.getAllPlaylistType({
            pager: {
                pageSize: this.props.audioList.all.pager.pageSize,
                current: page,
            },
        });
    }
    render() {
        const { title, subtitle } = this.getTopic();
        //let { audios: audioList = [], total, pager = this.defaultPager } = this.props.audioList.all||{};   
        //const {labels}=this.props
        let img = '';
        let imgContent = '';
        const playList = this.props.playlistInfos.map((x, i) => {
            const { title, subtitle, playlistid, thumb } = x;
            const { labels } = this.props;
            return (
                <li className="topCategoryList__item" key={i}>
                    <a href="javascript:;" onClick={e => this.gotoPlayTypePage(playlistid, labels)}>
                        <div className="topCategoryList__img">
                            <img src={agent.getApiUrl(thumb)} alt={title} />
                        </div>
                        <p className="topCategoryList__txt1">
                            {title}
                            <br />
                            <span style={{ fontSize: '18px' }}>{subtitle}</span>
                        </p>
                    </a>
                </li>
            );
        });

        return (
            <div className={imgContent} id="topic_music">
                <div className="musicContents__inner">
                    <div className={img}>
                        <div className="musicKv__titleBox">
                            <h1 className="topicKv__title">{title}</h1>
                            <p className="topicKv__txt">{subtitle}</p>
                        </div>
                    </div>
                    <div className="musicList__header">
                        <h2 className="musicList__title">歌单分类主题</h2>
                        <div className="musicList__header__select">
                            <div className="u-selectWrapp">
                                <select ref={ref => (this.selectRef = ref)} onChange={this.changePlayList.bind(this)}>
                                    {this.props.playlistInfos.map((x, i) => {
                                        const { playlistid, title } = x;

                                        return (
                                            <option key={i} value={playlistid}>
                                                {title}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="otherMusicList" style={{ padding: "4.6875% 3.125% 3.8125%" }}>
                        <div className="topSection__main">
                            <div className="topCategoryList">
                                <ul className="topCategoryList__items">
                                    <li className="">
                                    </li>
                                    {playList}
                                </ul>{/**跳转playList常量，返回布局方式 */}
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        playlistInfos: state.playlist.info.infos,
        audioList: state.playlist.list,
        search: state.router.location.search,
        labels: state.labels.labelsDataAll,
    }),
    dispatch => ({
        getPlaylistInfos: send =>
            dispatch({
                type: PLAYLIST_GET_INFO,
                payload: agent.PlayList.getInfo(send),
                send,
            }),
        getAllPlaylistType: send =>
            dispatch({
                type: PLAYLIST_GET_TYPE_ALL,
                payload: agent.PlayList.getAllType(send),
                send,
            }),
        unLoadTopic: () =>
            dispatch({
                type: TOPIC_DETAIL_UNLOAD
            }),
        loadLabelAll: () => {
            return dispatch({
                type: MUSIC_SEARCH_LABEL_LOAD_All,
                payload: agent.Music.searchLabelAlls(),
            });
        },
    })
)(AllTopicMusic);
